import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CKIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CK" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <G clipPath="url(#b)">
        <Path fill="#2E42A5" d="M0 0h8.8v7.2H0z" />
        <Path
          fill="#F7FCFF"
          d="m-1.802 6.5 1.98.869L8.245.945 9.29-.346l-2.118-.29-3.29 2.768-2.649 1.865L-1.802 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m-1.531 7.108 1.009.505 9.436-8.08H7.498l-9.029 7.575Z"
        />
        <Path
          fill="#F7FCFF"
          d="M9.202 6.5 7.444 7.616-.845.944-1.89-.346l2.118-.29 3.29 2.768 2.649 1.865L9.202 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m9.135 6.937-1.01.504-4.018-3.46-1.19-.386L-1.99-.342h1.417L4.33 3.502l1.303.463 3.502 2.972Z"
        />
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M4 0h-.8v3.2h-4V4h4v3.2H4V4h4v-.8H4V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M2.45 0h2.3v2.45L8 2.4v2.3l-3.25.05V7.2h-2.3V4.75L-.8 4.7V2.4l3.25.05V0Zm.75 3.2h-4V4h4v3.2H4V4h4v-.8H4V0h-.8v3.2Z"
          clipRule="evenodd"
        />
      </G>
      <Path
        fill="#fff"
        d="M11.387 7.007h.523l-.411.416.16.657-.514-.37-.326.228.11.245h.525l-.412.416.137.565.142-.37.242.537h.524l-.411.417.045.187h.58l.207-.537.242.537h.524l-.412.416.16.657-.513-.37-.53.37.18-.657-.43-.38.106.433-.513-.369-.53.37.179-.657-.471-.417h.615l.041-.107-.468-.337-.529.369.179-.657-.47-.416h.614l.206-.537.028.063.079-.286-.47-.416h.613l.206-.536.243.536Zm2.715-.024h.525l-.412.417.06.25.005-.012.242.536h.525l-.412.417.159.656-.513-.37-.345.24.088.195h.524l-.411.416.159.657-.513-.37-.53.37.178-.657-.47-.416h.615l.206-.537.06.135.088-.32-.47-.416h.614l.1-.262-.312-.224-.53.369.179-.657-.471-.417h.615l.206-.536.241.536Zm-1.406-.629h.525l-.412.417.159.657-.513-.37-.53.37.18-.657-.471-.417h.615l.206-.536.241.536Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
      <ClipPath id="b">
        <Path fill="#fff" d="M0 0h8.8v7.2H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
